import React from 'react'

const Title = ({title}) => {
  return (
    <div className='title'>{title}</div>
  )
}

export default Title